var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenantArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29199 9.99935C2.29199 15.7802 4.21949 17.7077 10.0003 17.7077C15.7812 17.7077 17.7087 15.7802 17.7087 9.99935C17.7087 4.21852 15.7812 2.29102 10.0003 2.29102C4.21949 2.29102 2.29199 4.21852 2.29199 9.99935Z",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10742 8.79688C7.10742 8.79688 9.10076 11.7019 10.0008 11.7019C10.9008 11.7019 12.8924 8.79688 12.8924 8.79688",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantArrow);
export default __webpack_public_path__ + "static/media/tenantArrow.9a491f1aa3e7159997c648c0b43427fe.svg";
export { ForwardRef as ReactComponent };